/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Instructions from './Instructions/index'
import No from './No/index'
import Picture from './Picture/index'
import React from 'react'
import Review from './Review/index'
import Welcome from './Welcome/index'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Content({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/ImageCapture/Questions/Question/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let imageCaptureQuestionTypeValueData = fromData.useDataValue({ viewPath,
context: 'imageCaptureQuestion',
path: 'type',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: imageCaptureQuestionTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Welcome'}>
<Welcome
  viewPath={`${viewPath}/Welcome`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Instructions'}>
<Instructions
  viewPath={`${viewPath}/Instructions`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Picture'}>
<Picture
  viewPath={`${viewPath}/Picture`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Review'}>
<Review
  viewPath={`${viewPath}/Review`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}